<script setup lang="ts">
import de from 'flag-icons/flags/4x3/de.svg';
import es from 'flag-icons/flags/4x3/es.svg';
import eu from 'flag-icons/flags/4x3/eu.svg';
import fr from 'flag-icons/flags/4x3/fr.svg';
import gb from 'flag-icons/flags/4x3/gb.svg';
import it from 'flag-icons/flags/4x3/it.svg';
import nl from 'flag-icons/flags/4x3/nl.svg';
import us from 'flag-icons/flags/4x3/us.svg';
import xx from 'flag-icons/flags/4x3/xx.svg';
import {computed, type HTMLAttributes} from 'vue';
import {tw} from "../../utils/tailwind.ts";

const props = defineProps<{
    country: string
    class?: HTMLAttributes['class']
}>();

const flagComponent = computed(() => {
    const normalized = (props.country || '').toLowerCase();
    const final = normalized === 'en' ? 'gb' : normalized;

    const flags: Record<string, any> = {
        nl, gb, de, fr, it, es, us, eu, xx
    };

    const component = flags[final] || flags.xx;
    
    if (!flags[final]) {
        console.warn(`Flag for country "${props.country}" (final: "${final}") not found, using placeholder.`);
    }

    return component;
});
</script>

<template>
    <component
        :is="flagComponent"
        :alt="country"
        :class="tw('w-full object-contain aspect-[4/3] max-w-5', props.class)"
    />
</template>
